import { render, staticRenderFns } from "./UserGroupManagement.vue?vue&type=template&id=08e0aa22&"
import script from "./UserGroupManagement.vue?vue&type=script&lang=js&"
export * from "./UserGroupManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupManagement.vue?vue&type=style&index=0&id=08e0aa22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QDialog})
